import { ModelType } from '@livv/models';
import { getStatisticLink } from '@livv/utils/helpers';
import { FC } from 'react';
import { PlainLink } from '@components/Links';
import OpenInNewCard from '@components/OpenInNewCard';
import useAmplitude from '@utils/hooks/useAmplitude';
import { TrackingEventName } from '@utils/types/amplitude/events';

interface StatisticEntryCardProps {
    id: string;
    title: string;
}

const StatisticEntryCard: FC<StatisticEntryCardProps> = ({ id, title }) => {
    const { track } = useAmplitude();

    const handleClick = () => {
        track({
            name: TrackingEventName.DECISION_EXTRA_CONTENT_CONSUMED,
            params: {
                target_document_id: id,
                target_document_type: ModelType.STATISTIC,
            },
        });
    };

    return (
        <PlainLink
            dataTestId="linked-statistic"
            href={getStatisticLink(id)}
            onClick={handleClick}
            underline="never"
            openInNewTab
        >
            <OpenInNewCard label={title} />
        </PlainLink>
    );
};
export default StatisticEntryCard;
